import BulletList from "@tiptap/extension-bullet-list";
import OrderedList from "@tiptap/extension-ordered-list";
import Paragraph from "@tiptap/extension-paragraph";
import Typography from "@tiptap/extension-typography";
import Underline from "@tiptap/extension-underline";
import { Markdown } from "tiptap-markdown";

import CustomLink from "./extensions/link";
import CustomListItem from "./extensions/list-item";

export const TextareaWysiwygExtensions = [
  Markdown.configure({ html: false }),
  CustomLink.configure({
    openOnClick: true,
    autolink: true,
  }),
  Paragraph.configure({
    HTMLAttributes: {
      class: "text-gray-600",
    },
  }),
  Underline,
  CustomListItem,
  BulletList.configure({
    itemTypeName: "listItem",
  }),
  OrderedList.configure({
    itemTypeName: "listItem",
  }),
  Typography,
];
